import CreateValueModule from "@/redux/create-value-module";

import {
    $CheckoutCustomerDetailsFormModuleName,
    TCheckoutCustomerDetailsFormState
} from "./checkoutCustomerDetailsForm.types";

const { constants: _constants, actions } =
    CreateValueModule<TCheckoutCustomerDetailsFormState>(
        $CheckoutCustomerDetailsFormModuleName,
        {
            deliveryAddressId: null,
            paymentAddressId: null,
            isLoading: false
        }
    );

export const clear = actions.clear;
export const set = actions.set;
export const update = actions.update;

export const constants = _constants;
